module.exports = __webpack_public_path__ + "static/women-hero-mobile.e4de8b2a.webp";